export class TableColumnTopValue {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "value",
            "baseName": "value",
            "type": "string",
            "format": ""
        },
        {
            "name": "share",
            "baseName": "share",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TableColumnTopValue.attributeTypeMap;
    }
    constructor() {
    }
}
